<template>
  <div class="card-container">
    <div
      class="card-thumbnail"
      v-bind:style="{ 'background-image': 'url(' + thumbnail + ')' }"
      alt="thumbnail"
    />
    <div class="card-content">
      <p v-html="subtitle" class="card-content-subtitle"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: ["title", "subtitle", "thumbnail"]
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap");

.card-container {
  width: 165px;
  height: 165px;
  border: 1px solid #dee1e3;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  transition: transform 250ms ease-in-out;
  font-family: "Gamja Flower", cursive;
}
.card-container:hover {
  transform: scale(1.02);
}
.card-container:active {
  transform: scale(0.95);
}
.card-thumbnail {
  width: 100%;
  height: 190px;
  display: block;
  object-fit: cover;
}
.card-content {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  text-align: left;
  padding-top: 15px;
}
.card-content-subtitle {
  color: #333333;
  margin-left: 7px;
  font-size: 1.1rem;
}
</style>
